import { readonly } from 'vue'

import type { SecurityBlockerEmailsBlocked } from '@fondof-ui/composables/auth/types'
import { useCookieStorage } from 'internal/composables'

export const useLoginBlocked = () => {
  const blocked = useCookieStorage<SecurityBlockerEmailsBlocked>('blocked', {})

  const setBlockedDuration = (email: string, duration: number) => {
    if (!blocked.value[email]) {
      blocked.value[email] = {
        duration,
        end: 0,
      }
    }

    blocked.value[email].duration = duration
  }

  const updateBlockedEnd = (email: string, end: number) => {
    if (blocked.value[email].end <= new Date().getTime()) {
      blocked.value[email].end = end
    }
  }

  return {
    blocked: readonly(blocked),
    setBlockedDuration,
    updateBlockedEnd,
  }
}
